import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { i18n } from "@/core/plugins/i18n";
import "@/assets/tailwind.css";
import { useDayjs } from '@/core/hook/useDayjs';
// General Font
import 'vfonts/Lato.css'
// Monospace Font
import 'vfonts/FiraCode.css'
import naive from "naive-ui";
// PrimeVue config and css
import PrimeVue from "primevue/config";
import 'primeicons/primeicons.css';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';     //optional for column grouping
import Row from 'primevue/row';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import Checkbox from 'primevue/checkbox'
import Menubar from 'primevue/menubar';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup'
import ToastService from 'primevue/toastservice'
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import Message from 'primevue/message';
import InputSwitch from 'primevue/inputswitch';
import ToggleButton from 'primevue/togglebutton'
import Button from 'primevue/button'
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';

const { setTimezone } = useDayjs()
setTimezone('Asia/Taipei') // 設定默認時區
//imports for app initialization
import ApiService from "@/core/services/ApiService";
const app = createApp(App);

app.use(i18n);
app.use(store);
app.use(router);
app.use(naive);
app.use(PrimeVue);
app.use(ToastService);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Row", Row);
app.component("InputText", InputText);
app.component("Dropdown", Dropdown);
app.component("MultiSelect", MultiSelect)
app.component("Checkbox", Checkbox)
app.component("Menubar", Menubar)
app.component("Avatar", Avatar);
app.component("AvatarGroup", AvatarGroup);
app.component("Toast ", Toast);
app.component("Dialog ", Dialog);
app.component("Message ", Message);
app.component("InputSwitch", InputSwitch);
app.component("ToggleButton", ToggleButton);
app.component("Button", Button)
app.component("Splitter", Splitter);
app.component("SplitterPanel", SplitterPanel);
ApiService.init(app);
app.mount("#app")

export default app
// createApp(App).use(store).use(router).use(naive).mount("#app");
